export default __webpack_public_path__ + "static/media/clearservices.32158825.jpg";